import script from "./HotContentArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./HotContentArea.vue?vue&type=script&setup=true&lang=ts"

import "./HotContentArea.vue?vue&type=style&index=0&id=215d18b4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-215d18b4"]])

export default __exports__